import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { isAuthenticated, getUserInfo } from '../lib/auth';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle Contact Us click - navigate to Energy Audit page and scroll to form
  const handleContactClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/consulting') {
      // Already on the page, just scroll
      document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Navigate then scroll
      navigate('/consulting');
      setTimeout(() => {
        document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { name: 'Bungee Fitness', path: '/bungee' },
    { name: 'Aerial Kids', path: '/aerial' },
    { name: 'Strength Workouts', path: '/workouts' },
    { name: 'Schedule', path: '/events' }
  ];

  const isLoggedIn = isAuthenticated();
  const user = isLoggedIn ? getUserInfo() : null;

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-text">GoCalFit</span>
          <span className="logo-tagline">Serious movement. Serious play.</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path || location.pathname.startsWith(`${link.path}/`) ? 'active' : ''}`}
            >
              {link.name}
            </Link>
          ))}
          {isLoggedIn ? (
            <>
              {/* Admin/Portal nav links hidden for now — re-enable when portal is ready */}
              <Button className="nav-cta" onClick={handleContactClick}>Contact Us</Button>
            </>
          ) : (
            <>
              <Button className="nav-cta" onClick={handleContactClick}>Contact Us</Button>
            </>
          )}
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${location.pathname === link.path || location.pathname.startsWith(`${link.path}/`) ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Button className="mobile-nav-cta" onClick={handleContactClick}>Contact Us</Button>
        </nav>
      )}
    </header>
  );
};

export default Header;
